function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M82.5302 119.77H87.3902C89.6702 119.77 91.8202 119.04 93.3302 117.76C94.8302 116.5 95.5302 114.8 95.2502 113.12L88.1402 71.25C87.1902 65.25 80.4102 60.72 72.3502 60.72H23.2602C15.1802 60.72 8.41019 65.25 7.49019 71.2L0.360187 113.12C0.0701869 114.8 0.7702 116.5 2.2802 117.76C3.7802 119.04 5.9402 119.77 8.2202 119.77H13.0702L0.720203 147.43C-0.0897972 149.23 0.320189 151.21 1.80019 152.74C3.29019 154.29 5.68021 155.2 8.23021 155.2H17.3502L23.0702 180.76C24.3502 186.48 30.9202 190.63 38.7002 190.63H56.9402C64.7102 190.63 71.2902 186.47 72.5502 180.76L78.2802 155.2H87.4002C89.9502 155.2 92.3402 154.29 93.8102 152.74C95.3102 151.2 95.7102 149.22 94.9002 147.43L82.5302 119.77Z",
  fill: "#EA5454"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M69.6102 51.5601C69.5302 51.7001 69.4403 51.8301 69.3503 51.9701C67.0303 55.5701 64.0702 58.5801 60.6602 60.7501C60.8702 60.7301 61.0802 60.7201 61.3002 60.7201H63.9203L47.6502 86.9101L31.6003 60.7201H34.3002C34.5202 60.7201 34.7302 60.7301 34.9402 60.7501C31.5202 58.5701 28.5402 55.5501 26.2202 51.9301C26.1402 51.8101 26.0702 51.6801 25.9902 51.5601H69.6102Z",
  fill: "#D20915"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M47.8106 63.34C65.3015 63.34 79.4806 49.1609 79.4806 31.67C79.4806 14.1791 65.3015 0 47.8106 0C30.3197 0 16.1406 14.1791 16.1406 31.67C16.1406 49.1609 30.3197 63.34 47.8106 63.34Z",
  fill: "#EA5454"
});

var SvgFemale = function SvgFemale(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 191,
    viewBox: "0 0 96 191",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFemale, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/female.ace99a73.svg";
export { ForwardRef as ReactComponent };